import { Theme } from '@busybusy/webapp-react-ui';
import { DateTime } from 'luxon';
import { AreaProps, BarProps, CartesianGridProps, TooltipProps, YAxisProps } from 'recharts';

export function getDefaultDashboardYAxisProps(theme: Theme.DARK | Theme.LIGHT): Omit<YAxisProps, 'dataKey'> {
  return {
    tickMargin: 20,
    interval: 'preserveStartEnd',
    tickCount: 5,
    width: 80,
    ...getDefaultAxisProps(theme),
  };
}

export function getDefaultDashboardCartesianGridProps(theme: Theme.DARK | Theme.LIGHT): CartesianGridProps {
  return {
    stroke: theme === Theme.DARK ? '#828b97cc' : '#a7a7a8cc',
    vertical: false,
    strokeWidth: 0.25,
  };
}

export function getDefaultDashboardAreaProps(theme: Theme.DARK | Theme.LIGHT): Omit<AreaProps, 'dataKey'> {
  return {
    type: 'monotone',
    dot: false,
    activeDot: { r: 4 },
    stroke: theme === Theme.DARK ? '#36c6dd' : '#38e0ac',
    strokeWidth: 2,
    fillOpacity: 1,
    fill: theme === Theme.DARK ? '#305a6e' : '#d7f9ee',
  };
}

export function getDefaultDashboardBarComponentProps(): Omit<BarProps, 'dataKey'> {
  return {
    strokeWidth: 0,
    fillOpacity: 1,
  };
}

export function getDefaultDashboardVisComponentProps() {
  return {
    type: 'monotone',
    dot: false,
    activeDot: { r: 4 },
  };
}

export function getDefaultTooltipProps(): TooltipProps {
  return {
    labelStyle,
    itemStyle,
    // Separator between the name and the value since we aren't using a name set to nothing
    separator: '',
  };
}

export function dashboardTooltipDateFormatter(tickItem: number) {
  return DateTime.fromSeconds(tickItem, { zone: 'utc' }).toFormat('MMMM');
}

const itemStyle = {
  color: '#30373d',
  fontSize: '13px',
  fontWeight: '600',
  fontFamily: '"Nunito Sans", sans-serif',
  lineHeight: '24px',
};

const labelStyle = {
  ...itemStyle,
  fontWeight: 600,
};

function xAxisFormatter(tickItem: number) {
  return DateTime.fromSeconds(tickItem, { zone: 'utc' }).toFormat('MMM');
}

export function getDefaultAxisProps(theme: Theme.DARK | Theme.LIGHT) {
  return {
    tickSize: 0,
    tick: { fontSize: 12, fill: theme === Theme.DARK ? '#828b97' : '#a7a7a8' },
    axisLine: false,
  };
}
